export const WAITLIST_FUNNEL_ID = 'waitlist';

export const config = {
  id: 'waitlist',
  path: '/waitlist',
  show: () => true,
};
